// import axios, {AxiosResponse} from 'axios';
import fetch from 'node-fetch';



export type xhrType = 'GET' | 'POST';

interface IXhrHelper<RequestDataGeneric> {
  name: string;
  type: xhrType;
  url: string;
  requestData?: RequestDataGeneric;
  credentials?:string;
  headers?:object;
}

export async function fetchHelper<RequestDataGeneric, ResponseDataGeneric>({
  name,
  type,
  url,
  requestData,
  credentials,
  headers
}: IXhrHelper<RequestDataGeneric>): Promise<ResponseDataGeneric> {
  let params = {};

  const options = {
    headers: headers || {},
  //  credentials: 'include',
    method: type,
  };
   if(credentials){
     options['credentials'] = credentials;
   }
  if (type === 'POST') {

    options.body = JSON.stringify(requestData);
  }

  const rawResponse = await fetch(url, options);
  const respJson = await rawResponse.json();
 
  return respJson;
}
